var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPictoPin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38.523,
    height: 49.128,
    viewBox: "0 0 38.523 49.128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pin",
    transform: "translate(-1373 -823.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "np_pin-location_2799224_000000",
    d: "M25.323,0c7.909,0,14.3,1.485,14.3,3.349,0,1.939-8.45,4.129-14.3,5.186-5.85-1.007-14.409-3.273-14.409-5.186C10.914,1.486,17.305,0,25.323,0Z",
    transform: "translate(1366.993 863.465)",
    fill: "#212631",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "np_pin-location_2799224_000000-2",
    "data-name": "np_pin-location_2799224_000000",
    d: "M29.746,0a18.7,18.7,0,0,1,18.69,18.832c0,10.9-11.044,23.222-18.69,29.168C22.1,42.336,10.914,29.593,10.914,18.832A18.734,18.734,0,0,1,29.746,0Z",
    transform: "translate(1362.586 824)",
    fill: "#00d480",
    stroke: "#fff",
    strokeWidth: 1,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "np_ok_950322_000000",
    d: "M15.672,30.068l6.214,6.148L32.519,21.922",
    transform: "translate(1368.828 813.355)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictoPin);
export default __webpack_public_path__ + "static/media/picto-pin.bf984199b539dcfacaea7f296697ebfa.svg";
export { ForwardRef as ReactComponent };